import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import RadiothonBanner from '~/main/components/RadiothonBanner2024';
import { fetchNodeIfNeeded } from '~/nodes/actions';
import Prizes from '~/main/components/Prizes';

const Radiothon = (props) => {
	const { dispatch, nodes } = props;
	useEffect( () => {
		dispatch(fetchNodeIfNeeded('radiothon2024'))
	}, [])
	return (
		<div className="radiothon">
			<RadiothonBanner />
			{ nodes['radiothon2024'] && nodes['radiothon2024'].body && 
        <div className="margin">
					<div dangerouslySetInnerHTML={{ __html: nodes['radiothon2024'].body[0].value}}></div>
				</div>
			}
			 <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <filter id="squiggly-0">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="0"/>
          <feDisplacementMap id="displacement" in="SourceGraphic" in2="noise" scale="6" />
        </filter>

        <filter id="squiggly-1">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="1"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
        </filter>
        
        <filter id="squiggly-2">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="2"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
        </filter>

        <filter id="squiggly-3">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="3"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
        </filter>
        
        <filter id="squiggly-4">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="4"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
        </filter>
      </defs> 
    </svg>


			<Prizes category="radiothon" variant="list" />
		</div>
	)
}

Radiothon.fetchData = (store, route, match) => {
	return store.dispatch(fetchNodeIfNeeded('radiothon'))
}

export default connect( state => ( { nodes: state.nodes } )) (Radiothon)